import {Mapper} from '../../../core/abstracts/mapper.abstract';
import {Injectable} from '@angular/core';
import {AvailableReportColumn} from '../model/available-report-column.model';
import {ReportRequest} from '../model/report-request.model';
import {ReportVehicleDetails} from '../model/report-item-details.model';

@Injectable({providedIn: 'root'})
export class ReportRequestMapper extends Mapper<{
  reportScheme: AvailableReportColumn[],
  itemsDetails: ReportVehicleDetails
}, ReportRequest> {

  override map(source: { reportScheme: AvailableReportColumn[]; itemsDetails: ReportVehicleDetails; }): ReportRequest {
    return new ReportRequest(
      this.resolveReportScheme(source.reportScheme),
      source.itemsDetails
    )
  }

  private resolveReportScheme(columns: AvailableReportColumn[]): string[] {
    return columns.map(column => column.column);
  }
}
